import { i18n } from "@lingui/core";
import type { MobilityAd } from "@mobility-item-page/types";
import { useMemo } from "react";
import { useValidDealerContext } from "../context/DealerProviderContext.tsx";

type CannedMessages = {
  id: string;
  message: string;
};

const getCannedMessages = (adViewType: MobilityAd["adViewType"]): CannedMessages[] => {
  const messages: CannedMessages[] = [];
  switch (adViewType) {
    case "car-used":
      messages.push(
        {
          id: "damages",
          message: i18n.t({ id: "dealer.contactForm.cannedMessages.damages", message: "Is the car free of damage?" }),
        },
        {
          id: "carTrade",
          message: i18n.t({ id: "dealer.contactForm.cannedMessages.carTrade", message: "Can I trade in my car?" }),
        },
        {
          id: "testDrive",
          message: i18n.t({
            id: "dealer.contactForm.cannedMessages.testDrive",
            message: "Can we arrange a time for a test drive?",
          }),
        },
        {
          id: "financing",
          message: i18n.t({
            id: "dealer.contactForm.cannedMessages.financing",
            message: "Can I get an offer for financing?",
          }),
        },
      );
      break;
    case "car-new":
      messages.push(
        {
          id: "homeDelivery",
          message: i18n.t({
            id: "dealer.contactForm.cannedMessages.homeDelivery",
            message: "Do you offer home delivery?",
          }),
        },
        {
          id: "carTrade",
          message: i18n.t({ id: "dealer.contactForm.cannedMessages.carTrade", message: "Can I trade in my car?" }),
        },
        {
          id: "testDrive",
          message: i18n.t({
            id: "dealer.contactForm.cannedMessages.testDrive",
            message: "Can we arrange a time for a test drive?",
          }),
        },
        {
          id: "financing",
          message: i18n.t({
            id: "dealer.contactForm.cannedMessages.financing",
            message: "Can I get an offer for financing?",
          }),
        },
      );
      break;
  }
  return messages;
};

export const useCannedMessages = () => {
  const {
    external: { adViewType },
  } = useValidDealerContext();
  return useMemo(() => {
    if (adViewType) {
      return { cannedMessages: getCannedMessages(adViewType) };
    }
    return { cannedMessages: [] };
  }, [adViewType]);
};
